'use client';

import styled from 'styled-components';
import Image from 'next/image';

export const StyledImageWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 100%;
  border-radius: var(--radius-full);
  overflow: hidden;
  max-width: 226px; /* Set your desired max width */
  max-height: 226px; /* Set your desired max height */
`;

export const StyledLegendCard = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  gap: var(--size-1);
  border: 3px solid var(--c-grey-1);
  border-radius: var(--radius-lg);
  width: 250px;
  max-width: 100%;
  padding: var(--radius-lg);
  flex-grow: 1;
  text-align: center;
  box-sizing: border-box; /* Ensure padding is included in the width */
`;

export const StyledMetaContainer = styled.div`
  h3 {
    margin-bottom: var(--size-half);
  }

  p {
    margin: 0;
  }
`;

export const StyledImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: var(--radius-full);
  overflow: hidden;
`;

export const StyledImage = styled(Image)`
  object-fit: cover;
  border-radius: var(--radius-full);
  max-width: 100%;
  max-height: 100%;
`;
